export default "__VITE_ASSET__B3qAu5kM__"